<template>
  <div>
    <v-dialog v-model="$store.state.dialog_pedido" fullscreen hide-overlay>
      <v-card>
        <v-toolbar color="grey lighten-5" flat>
          <v-img 
            alt="Mona Logo" 
            class="shrink mr-2" 
            contain :src="require('../assets/mona_logo.png')" 
            transition="scale-transition" width="50" />
          <v-toolbar-title>Pedido</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$store.state.dialog_pedido = false">
            <v-icon color="grey darken-1">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="px-0">
          <v-stepper v-model="stepper" class="elevation-0">
              <v-stepper-header class="elevation-1">
                <v-stepper-step :complete="stepper > 1" step="1" color="green darken-1">Dirección</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="stepper > 2" step="2" color="green darken-1">Menú</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-row v-if="loadingDirecciones">
                    <v-col sm="12" class="px-2">
                      <v-progress-linear
                        indeterminate
                        color="grey"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                  <v-row class="text-center" v-if="direcciones.length == 0 && loadingDirecciones == false">
                    <v-col>
                      <p class="caption">El cliente no tiene dirección asignada.</p>
                    </v-col>
                  </v-row>
                  <v-card v-if="!loadingDirecciones && selectedCliente != null">
                    <v-card-text>
                      <v-row>
                        <v-col class="text-center">
                          <p class="title">Cliente</p>
                        </v-col>
                      </v-row>
                      <v-row class="text-center">
                        <v-col sm="12" md="4">
                          {{selectedCliente.field_nombre_cli.und[0].value}}
                          <p class="caption">Nombre</p>
                        </v-col>
                        <v-col sm="12" md="4">
                          {{selectedCliente.field_apellidos_cli.und[0].value}}
                          <p class="caption">Apellido</p>
                        </v-col>
                        <v-col sm="12" md="4">
                          {{selectedCliente.field_telefono_cli.und[0].value}}
                          <p class="caption">Teléfono</p>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row class="ma-2">
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogNewAddress = true">Nueva Dirección</v-btn>
                      </v-row>
                      <v-row>
                        <v-col class="text-center">
                          <p class="title">Direcciones</p>
                        </v-col>
                      </v-row>
                      <v-row v-for="item in direcciones" :key="item.nid" class="text-center">
                        <v-col sm="12" md="3">
                          {{item.calle}}
                          <p class="caption">Calle</p>
                        </v-col>
                        <v-col sm="12" md="3">
                          {{item.colonia}}
                          <p class="caption">Colonia</p>
                        </v-col>
                        <v-col sm="12" md="3">
                          {{item.ciudad}}
                          <p class="caption">Ciudad</p>
                        </v-col>
                        <v-col md="3" sm="12">
                          <div>
                            <v-btn icon @click="selectAddress(item)">
                              <v-icon large>home</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card>
                    <v-card-text>
                      <Menu @checkout="checkout"/>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="stepper = 1">Atrás</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNewAddress"  
      persistent 
      :overlay="false"
      transition="dialog-transition"
    >
      <v-card class="elevation-0">
        <v-card-title>
            Nueva Dirección
            <v-spacer></v-spacer>
            <v-btn text @click="dialogNewAddress = false">Cerrar</v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <NewAddressForm :selectedCliente="selectedCliente" @newAddressSaved="newAddressSaved"/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="payDialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-form ref="pedido_form" v-on:submit.prevent="createOrder">
          <v-card-title>
            Ordenar
          </v-card-title>
          <v-card-text v-if="!processingPayment">
            <v-row>
              <v-col sm="12">
                <p>Forma de Pago</p>
                <v-radio-group 
                  v-model="formaPago"
                  :rules="requiredRules"
                  required>
                  <v-radio label="Efectivo" value="Efectivo"></v-radio>
                  <v-radio label="Tarjeta" value="Tarjeta"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col sm="12">
                <v-select
                  v-model="selectedRepartidor"
                  :items="repartidores"
                  item-text="name"
                  item-value="uid"
                  :rules="requiredRules"
                  label="Repartidores"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <p class="title">Total ${{getTotalOrder}}</p>
            </v-row>
          </v-card-text>
          <v-card-text v-if="processingPayment">
            <v-row>
              <v-col sm="12" class="text-center">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="black"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="createOrder">Ordenar</v-btn>
            <v-btn text @click="payDialog = false">Cancelar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import functions from '@/mixins/functions'
import Loader from './Loader'
import NewAddressForm from './NewAddressForm'
import Menu from './Menu'
import {mapGetters} from 'vuex'

export default {
  name: 'Pedido',
  components: {
    NewAddressForm,
    Loader,
    Menu
  },
  mixins: [
    functions
  ],
  props: ['selected_client_nid'],
  data() {
    return {
      selectedCliente: null,
      loadingCliente: false,
      direcciones: [],
      loadingDirecciones: false,
      selected_address: null,
      dialogNewAddress: false,
      calle: '',
      colonia: '',
      codigo_postal: '',
      ciudad: 'Mazatlán',
      estado: 'Sinaloa',
      observaciones: '',
      lat: null,
      lng: null,
      formattedAddress: '',
      valid: true,
      required: [
        v => !!v || 'Campo Requerido'
      ],
      stepper: 1,
      payDialog: false,
      orderType: null,
      formaPago: null,
      processingPayment: false,
      requiredRules: [
        v => !!v || 'Este campo es requerido.',
      ],
      repartidores: [],
      selectedRepartidor: null,
    }
  },
  created() {
    //console.log(this.selected_client_nid)
    //Load Cliente - Direcciones
    this.loadClientDetails(this.selected_client_nid)
    this.loadRepartidor()
  },
  methods: {
    loadRepartidor() {
      //Load Repartidores
        axios.get(this.$store.state.astilleroURL + '/api/views/services_repartidores?display_id=services_1', {
          headers: {
            'Content-Type': 'application/json',
            'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
            'X-CSRF-Token': this.$store.state.token
          }
        })
        .then(res => {
          this.repartidores = res.data
        })
        .catch(error => console.log(error))
    },
    selectAddress(item) {
      this.selected_address = item
      this.stepper = 2
      //console.log(item.nid)
      this.$store.commit('setAddress', item.nid)
      this.$store.commit('setSelectedAddress', item)
      this.$store.commit('setOrderType', 'Domicilio')
    },
    loadClientDetails(nid) {
      this.loadingCliente = true
      this.loadingDirecciones = true
      this.getNode(nid)
      .then(res => {
        //console.log('Selected cliente', res.data)
        this.$store.commit('setSelecedClient', res.data)
        this.selectedCliente = res.data
        this.loadingCliente = false
        //Load Direcciones
        axios.get(this.$store.state.astilleroURL + '/api/views/services_address_by_cliente?display_id=services_1&args[0]=' + this.selected_client_nid, {
          headers: {
            'Content-Type': 'application/json',
            'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
            'X-CSRF-Token': this.$store.state.token
          }
        })
        .then(res => {
          //console.log('Selected Direccion', res.data)
          this.direcciones = res.data
          this.loadingDirecciones = false
        })
        .catch(error => console.log(error))
        })
      .catch(error => console.log(error))
    },
    newAddressSaved() {
      //Reload Cliente - Direcciones
      this.loadClientDetails(this.selected_client_nid)
      this.dialogNewAddress = false
    },
    checkout() {
      this.payDialog = true
    },
    createOrder() {
      const data = {
        cliente_nid: this.getSelectedClient.nid,
        user_uid: this.getCurrentUser.user.uid,
        address_nid: this.getSelectedAddress.nid,
        order_type: this.getOrderType,
        total: this.getTotalOrder,
        items: this.getSelectedProducts,
        payment: this.formaPago,
        repartidor_uid: this.selectedRepartidor
      }
      if(this.$refs.pedido_form.validate()) {
        this.processingPayment = true
        this.sendOrder(data)
        .then(res => {
          this.processingPayment = false
          console.log(res.data)
          this.$store.commit('resetOrder')
          this.$emit('orderCompleted')
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
      'getSelectedClient',
      'getSelectedAddress',
      'getOrderType',
      'getSelectedProducts',
      'getTotalOrder',
    ])
  }
}
</script>

<style>

</style>